import React from "react";
import Fa from "./Fa";
/**
 * @param {*} props
 * @param {string} props.styleName
 */
export default class NoData extends React.Component {
  render() {
    return (
      <div className="loading">
        <p><Fa icon="eye-slash"></Fa>No hay datos que cumplan con los criterios definidos.</p>
      </div>
    );
  }
}
